import { render } from "./UIGlass.vue?vue&type=template&id=690fb59c&scoped=true"
import script from "./UIGlass.vue?vue&type=script&lang=js"
export * from "./UIGlass.vue?vue&type=script&lang=js"

import "./UIGlass.vue?vue&type=style&index=0&id=690fb59c&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-690fb59c"]])

export default __exports__